import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AppPaymentService } from "app/business/service/app/app-payment";
import { AppUserService } from "app/business/service/app/app-user.service";
import { AuthService } from "app/core/auth/auth.service";
import _ from "lodash";

@Component({
  selector: "app-add-payment-request-modal",
  templateUrl: "./add-payment-request-modal.component.html",
  styleUrls: ["./add-payment-request-modal.component.css"],
})
export class AddPaymentRequestModalComponent implements OnInit {
  form: any = {};
  dataSource: any = [];
  detail_list: any = [];
  detailExdList: any = [];
  selectionList: any = [];
  temp_detail_list: any = [];
  userProfile: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<AddPaymentRequestModalComponent>,
    private appPaymentService: AppPaymentService,
    private _authService: AuthService
  ) {
    this.userProfile = JSON.parse(this._authService.loginUser);
  }

  ngOnInit() { 
    if (this.data.detail_list != undefined) {
      this.detail_list = this.data.detail_list.map((res) => {
        return {
          ms24Id: res.detailId,
        };
      });
    }
    if (this.data.detailExdList != undefined) {
      this.detailExdList = this.data.detailExdList.map((res) => {
        return {
          ms24Id: res.detailId,
          detailId: res.detailId,
        };
      });
    }
    const formData = {
      uId: Number(this.userProfile.uId),
    };

    this.temp_detail_list = this.data.temp_detail_list;

    this.appPaymentService.getPaymentObjList(formData).then((res) => {
      this.dataSource = res;
      this.dataSource = this.dataSource.map((m) => {
        return {
          ...m,
          refNo: m.refNo,
          ms24FullRefNo : m.ms24FullRefNo,
          ms13FullRefNo : m.ms13FullRefNo,
          docNo: m.ms24FullRefNo,
          detailId: m.ms24Id,
          typeDocName: m.goodsName,
        };
      }); 
      this.dataSource.push(...this.data.temp_detail_list);
      this.dataSource = this.dataSource.filter(
        (f) => f.companyId == this.data.companyId
      );
      this.dataSource = _.differenceBy(this.dataSource, this.detailExdList, "detailId"); 
    });
  }

  selectionChanged(e) {
    this.selectionList = e.selectedRowsData;
  }
}
